<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Departure Purpose Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button
              v-if="$oauth.checkIfHasPermission(['export departure-purpose-summary-report'])"
              model="departure-purpose"
              :export-country="country"
              :export-date="range"
          />
          <refresh-button :click-function="departurePurposeSummaryReport"></refresh-button>
        </div>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs3 class="d-flex align-center">
              <custom-date-range-picker @change="departurePurposeSummaryReport" v-model="range"/>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="offices"
                  clearable
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Office"
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="office"
                  @change="departurePurposeSummaryReport"
              />
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Departure Countries"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="country"
                  @change="departurePurposeSummaryReport"
              />
            </v-flex>

          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-simple-table
                v-if="$oauth.checkIfHasPermission(['read departure-purpose-summary-report'])"
                class="elevation-0"
            >
              <thead>
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular indeterminate size="64"/>
              </v-overlay>

              <tr>
                <th class="text-center">S.N</th>
                <th class="text-left">Purpose</th>
                <th class="text-center">Male</th>
                <th class="text-center">Female</th>
                <th class="text-center">Other</th>
                <th class="text-center">Total</th>
              </tr>
              </thead>
              <tbody v-if="departure_purpose_data">
              <tr v-for="(item,i) in departure_purpose_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-left">{{ item.purpose }}</td>
                <td class="text-center">{{ item.male_traveller }}</td>
                <td class="text-center">{{ item.female_traveller }}</td>
                <td class="text-center">{{ item.other_traveller }}</td>
                <td class="text-center font-weight-bold text-decoration-underline text-primary cursor-pointer" @click="handlePurposeView(item)" :title="`view country wise`">{{ item.total }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td>No record found</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td class="text-center">#</td>
                <td class="text-left font-weight-bold">Total</td>
                <td class="text-center">{{ getTotal('male_traveller') }}</td>
                <td class="text-center">{{ getTotal('female_traveller') }}</td>
                <td class="text-center">{{ getTotal('other_traveller') }}</td>
                <td class="text-center font-weight-bold">{{ getTotal('total') }}</td>
              </tr>
              </tfoot>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const DEPARTURE_PURPOSE_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/departure-purpose`;

export default {
  name: "ADCountryWiseReport",
  data() {
    return {
      ADTypes: [
        "Arrival",
        "Departure",
        "Arrival Cancel",
        "Departure Cancel",
      ],
      departure_purpose_data: [],
      country_wise_arrival: [],
      country_wise_departure: [],
      office: null,
      range: {},
      country: [],
      table_data: []
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
      countries: "CountryList/all",
      officers: "UserList/all",
      offices: "OfficeList/offices"
    }),
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
      getOffices: "OfficeList/fetchCustomData"
    }),

    getTotal(key) {
      return _.sumBy(this.departure_purpose_data, function (o) {
        return o[key];
      });
    },
    handlePurposeView(item) {
      this.$router.push({
        name: 'CountryWiseDeparturePurposeViewReport',
        params: {
          purpose: item.purpose
        }
      })
    },
    departurePurposeSummaryReport() {
      let params = {};
      this.progressLinearLoading = true;
      if (this.range)
        params.date_range = this.range;
      if (this.country)
        params.country = this.country;

      if (this.office)
        params.office_id = this.office

      Http.get(DEPARTURE_PURPOSE_SUMMARY_REPORT_URL, {params: params})
          .then((res) => {
            this.departure_purpose_data = res.data.data;
            this.progressLinearLoading = false;
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }
  },

  mounted() {
    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }

    if (this.$store.state.CountryList.all.length === 0) {
      this.fetchCountries();
    }

    this.getOffices([2])
    // this.filters.offices = [this.$store.state.AuthUser.user.office_id];

    this.departurePurposeSummaryReport()
  }
}
</script>
